import React, { FC } from 'react'

import { EuiTitle, EuiText, EuiFlexGroup, EuiFlexItem, EuiBadge, EuiSpacer } from '@elastic/eui'

import { Persona } from 'api/interfaces/Persona'

export interface PersonaHeaderProps {
  persona: Persona
}

const PersonaHeader: FC<PersonaHeaderProps> = ({ persona }) => {
  return (
    <div>
      <EuiFlexGroup alignItems='center' gutterSize='m' responsive={false}>
        <EuiFlexItem>
          <div>
            <EuiTitle size='s'>
              <h5>{persona.name}</h5>
            </EuiTitle>
            <EuiSpacer size='s' />
            <EuiText size='s' color='subdued' style={{ whiteSpace: 'pre-wrap' }}>
              {persona.description}
            </EuiText>
          </div>
        </EuiFlexItem>
      </EuiFlexGroup>
    </div>
  )
}

export default PersonaHeader
